// extracted by mini-css-extract-plugin
export default {"container":"II","productarea":"JI","btn":"KI","promowrapper":"LI","upsellarea":"MI","subtitle":"NI","system":"OI","desc":"PI","cardswrap":"QI","cards":"RI","squareloadingcontainer":"SI","squareloading33":"TI"};
    if(module.hot) {
      // 1714654894029
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  